import useBreakpoint from "use-breakpoint";
import { BREAKPOINTS } from "../lib/constants";

const withBreakpointsConfig = (defaultBreakpoint, hydrateInitial) => {
  return useBreakpoint(BREAKPOINTS, defaultBreakpoint, hydrateInitial);
};

export default withBreakpointsConfig;
